import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-xl border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 backdrop-blur-sm shadow-sm select-none cursor-default",
  {
    variants: {
      variant: {
        default:
          "border-blue-500/30 bg-blue-600/80 text-white shadow-lg",
        secondary:
          "border-white/30 bg-white/40 text-slate-700 ",
        destructive:
          "border-red-500/30 bg-red-600/80 text-white shadow-lg",
        outline: "border-white/30 bg-white/20 text-slate-700 ",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  const glassStyle = {
    boxShadow: variant === 'default' || variant === 'destructive' 
      ? '0 4px 16px rgba(59,130,246,0.2), inset 0 1px 0 rgba(255,255,255,0.3)'
      : '0 2px 8px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.3)',
  };
  
  return (
    <div 
      className={cn(badgeVariants({ variant }), className)} 
      style={glassStyle}
      {...props} 
    />
  )
}

export { Badge, badgeVariants }
